module.exports = __webpack_public_path__ + "img/视频专栏未选中.2d8ea153.png";